export default __webpack_public_path__ + "static/media/photo23.39b1b262.jpg";